export default function getWhatchadoPath(url: string) {
  // This regex looks for either "stories" or "videos" followed by a "/" and captures the next segment
  const regex = /\/(stories|videos)\/([^\/?#]+)/;
  const match = url.match(regex);

  // If a match is found, return the second captured group, which is the segment after "stories" or "videos"
  return match ? match[2] : null;
}
